import { render } from "./MarketDefenceCard.vue?vue&type=template&id=3363a7f2&scoped=true"
import script from "./MarketDefenceCard.vue?vue&type=script&lang=js"
export * from "./MarketDefenceCard.vue?vue&type=script&lang=js"

import "./MarketDefenceCard.vue?vue&type=style&index=0&id=3363a7f2&lang=css"
import "./MarketDefenceCard.vue?vue&type=style&index=1&id=3363a7f2&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3363a7f2"]])

export default __exports__